/**
 * The 1-based number a version shows as ("Version N"). Versions are listed newest first, so N counts back from the
 * list's length. Undefined when the id is not among the versions, as for a reference template.
 */
export function versionNumber(
  versions: ReadonlyArray<{ id: string }>,
  versionId: string | null | undefined,
): number | undefined {
  const index = versions.findIndex((version) => version.id === versionId);
  return index >= 0 ? versions.length - index : undefined;
}
